import { memo, useCallback } from 'react';
import PropTypes from 'prop-types';

import classNames from 'classnames';
import './Element.scss';

const Element = ({ icon, isAnimation, onClick, path = undefined, selected = false, text, ...props }) => {
  const onClickLocal = useCallback(e => {
    e.preventDefault()
    e.stopPropagation()
    onClick(path)
  }, [path, onClick])

  return (
    <a
        {...props}
        className={classNames(
          "navigation-mobile__sidebar__group__element",
          { "navigation-mobile__sidebar__group__element--is-selected": selected },
          { "navigation-mobile__sidebar__group__element--is-animation": isAnimation }
        )}
        href={path}
        onClick={onClickLocal}
    >
      <div className="navigation-mobile__sidebar__group__element__bg"/>
      <div className="navigation-mobile__sidebar__group__element__icon">
        {icon}
      </div>
      <div className="navigation-mobile__sidebar__group__element__text">
        {text}
      </div>
    </a>
  )
}

Element.propTypes = {
  icon: PropTypes.element.isRequired,
  isAnimation: PropTypes.bool.isRequired,
  onClick: PropTypes.func.isRequired,
  path: PropTypes.string,
  selected: PropTypes.bool,
  text: PropTypes.string.isRequired,
}

export default memo(Element);